/**
 * This file is auto-generated from NewMessagesIndicator.loc.yml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const newMessages: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'New messages';
        case 'pl':
            return 'Nowe wiadomości';
    }
};
